module.exports = __webpack_public_path__ + "static/media/me.9f63afe1.jpg";